import { render, staticRenderFns } from "./InputMessages.vue?vue&type=template&id=26ff3038&"
import script from "./InputMessages.vue?vue&type=script&lang=ts&"
export * from "./InputMessages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports